import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducer';
import { Task } from '../../types/task';

export default function useTasks(): Task[] {
  const selectedCommunity = useSelector((state: RootState) => state.application.selectedCommunity);
  const taskMap = useSelector((state: RootState) => state.tasks.taskMap);

  if (!selectedCommunity) return [];
  return taskMap[selectedCommunity] || [];
}
